function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("path", {
  fill: "#1bc092",
  fillRule: "evenodd",
  d: "M5.69 12L16 1.679 14.378 0 5.691 8.725 1.622 4.624 0 6.248z"
});

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    width: 16,
    height: 12,
    viewBox: "0 0 16 12"
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/check.e7119449.svg";
export { SvgComponent as ReactComponent };